module.exports = __webpack_public_path__ + "img/84.6a8a7d0e.jpg";